import { createEvent } from 'effector';

import { RequestManagementState } from './RequestManagementState';

export const requestManagementEvent =
  createEvent<Partial<RequestManagementState>>('requestManagementEvent');
